/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { capitalize } from 'lodash';
import { PaginationShowHide } from '../../../../../../../../../../shared/design-system/components/organisms/table/types';
import Table from '../../../../../../../../../../shared/design-system/components/organisms/table';
import { formatDuration } from '../../utils/helper';
import { SeedAccountImages } from '../../../../../../../test-create-update/components/seed-esp-account/type';
import { Other } from '../../../../../../../../../../shared/svg/other';

const EspItemTable = ({
  data,
  espType,
  firebaseData,
  seedTestSenderEmailAccountId,
}) => {
  const [sort, setSort] = useState<any>({
    dataField: 'deliveredIn',
    order: 'desc',
  });

  const onSortChange = (field: string, order: 'asc' | 'desc') => {
    setSort({
      dataField: field,
      order,
    });
  };

  const sortedData = [...data].sort((a, b) => {
    if (sort.order === 'asc') {
      return a[sort.dataField] - b[sort.dataField];
    }
    return b[sort.dataField] - a[sort.dataField];
  });

  // Get all available IDs from Firebase data
  const firebaseIds = firebaseData ? Object.keys(firebaseData) : [];
  // Find matching Firebase data for current item's ID
  const firebaseItemData = firebaseIds.includes(
    seedTestSenderEmailAccountId?.toString(),
  )
    ? firebaseData[seedTestSenderEmailAccountId]
    : null;
  const firebaseEspData = firebaseItemData?.seedAccountEspWise?.[espType];
  const firebaseSeedPlacements = firebaseEspData?.seedPlacements;

  // Convert Firebase seedPlacements to the format expected by the table
  const firebaseTableData = firebaseSeedPlacements
    ? Object.values(firebaseSeedPlacements)?.map((placement: any) => ({
        email: placement.fromEmail,
        deliveredTo: placement.deliveredTo?.toLowerCase(),
        senderIP: placement.senderIp,
        deliveredIn: placement.deliveredIn
          ? typeof placement.deliveredIn === 'number'
            ? placement.deliveredIn
            : 0
          : 0,
      }))
    : null;

  // Use Firebase data if available, otherwise use current data
  const tableData = firebaseTableData || data;

  const sortedTableData = [...tableData].sort((a, b) => {
    if (sort.order === 'asc') {
      return a[sort.dataField] - b[sort.dataField];
    }
    return b[sort.dataField] - a[sort.dataField];
  });

  const getEmailTypeIcon = (emailType: string) => {
    if (SeedAccountImages[emailType]) {
      return (
        <img
          src={SeedAccountImages[emailType]}
          alt={emailType}
          width={16}
          height={16}
        />
      );
    }
    return <Other height={16} width={16} />;
  };

  return (
    <div className="sender-email-account-esp-item-table">
      <Table
        columns={[
          {
            dataField: 'email',
            text: 'Email Account',
            component: (cell) => (
              <span className="email-cell d-flex align-items-center gap-8">
                {getEmailTypeIcon(espType)}
                {cell}
              </span>
            ),
          },
          {
            dataField: 'deliveredTo',
            text: 'Delivered to',
            component: (cell) => (
              <span
                className={`delivered-to-cell ${
                  cell === 'inbox'
                    ? 'inbox'
                    : cell === 'spam'
                    ? 'spam'
                    : cell === 'other'
                    ? 'other'
                    : cell === 'undelivered'
                    ? 'undelivered'
                    : ''
                }`}
              >
                {capitalize(cell) || '-'}
              </span>
            ),
          },
          {
            dataField: 'senderIP',
            text: 'Sender IP',
            component: (cell) => <span>{cell || '-'}</span>,
          },
          {
            dataField: 'deliveredIn',
            text: 'Delivered in',
            component: (cell) => (
              <span>{Number?.isFinite(cell) ? formatDuration(cell) : '-'}</span>
            ),
            sort: true,
            onSort: onSortChange,
          },
        ]}
        data={sortedTableData}
        sort={sort}
        pagination={PaginationShowHide.HIDE}
        paginationOptions={{
          options: {
            limit: tableData?.length,
            page: 1,
            totalElements: tableData?.length,
          },
        }}
      />
    </div>
  );
};

export default EspItemTable;
